import type { Occasion } from '@/schemas/occasion.schema'

export interface OccasionNavModelProps {
  occasions: Occasion[]
}

export function useOccasionNavModel({ occasions }: OccasionNavModelProps) {
  return {
    occasions,
  }
}
